export default "__VITE_ASSET__K71n_h5q__"